document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".home-features-section");
  const phrases = container.querySelectorAll(".animated-heading .text-phrase");
  const bounceImages = gsap.utils.toArray(".bounce-image-feat");

  // Pin the entire component during scroll
  ScrollTrigger.create({
    trigger: container,
    start: "top top",
    end: "+=250%", // extend length clearly if needed for images transition
    pin: true,
    pinSpacing: true,
  });

  // Setup an animation timeline with scrub true
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: "top top",
      end: "+=250%",
      scrub: true,
    },
  });

  // Initial preparation explicitly defined
  gsap.set([phrases, bounceImages], { opacity: 0, y: 50, scale: 1 });
  gsap.set([phrases[0], bounceImages[0]], { opacity: 1, y: 0, scale: 1 });

  // Phrase 1 to phrase 2 (text + image explicitly)
  timeline
    .to(phrases[0], { y: 50, opacity: 0, duration: 0.5 }, "+=0.5")
    .fromTo(phrases[1], { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, scale: 1 }, "<+0.2")
    .to(bounceImages[0], { scale: 0.8, opacity: 0, duration: 0.5 }, "<")
    .fromTo(bounceImages[1], { scale: 0.8, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.5 }, "<");

  // Phrase 2 to phrase 3 transition (text + image explicitly)
  timeline
    .to(phrases[1], { y: 50, opacity: 0, duration: 0.5 }, "+=0.5")
    .fromTo(phrases[2], { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, scale: 1 }, "<+0.2")
    .to(bounceImages[1], { scale: 0.8, opacity: 0, duration: 0.5 }, "<")
    .fromTo(bounceImages[2], { scale: 0.8, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.5 }, "<");
});
